
export default {
  'steps': {
    'instruction': 'Instruction',
    'on': 'Sur',
    'step': 'étape',
    'gotoStep': 'Aller à cette étape'
  }
}
